const validate = (values) => {
  const errors = {}
  if (!values.resolution) {
    errors.resolution = 'Favor informar a solução do problema!'
  }
  return errors
}

export default validate
